module.exports = __webpack_public_path__ + "img/l7.6bd7123b.png";